'use client';

import { useEffect, useRef } from 'react';

type Props = {
  onIntersect: () => void;
} & React.ComponentProps<'div'>;

const IntersectionTrigger: React.FC<Props> = ({ onIntersect, ...rest }) => {
  const elRef = useRef(null);

  useEffect(() => {
    if (!elRef.current) return;
    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        onIntersect();
      }
    });
    observer.observe(elRef.current);
    return () => observer.disconnect();
  }, [onIntersect]);

  return <div ref={elRef} {...rest} />;
};

export default IntersectionTrigger;
